<template>
  <div>
    <v-form
      ref="regform"
      v-model="formValid"
      spellcheck="false"
      @submit="registerTry"
    >
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="qr"
            :rules="activeRules.qr"
            label="QR-code"
            type="number"
            required
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="email"
            :rules="activeRules.email"
            label="Email"
            type="email"
            required
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="emailRe"
            :rules="activeRules.emailRe"
            label="Email (Herhaling)"
            type="email"
            required
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="password"
            :rules="activeRules.password"
            label="Wachtwoord"
            type="password"
            required
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="passwordRe"
            :rules="activeRules.passwordRe"
            label="Wachtwoord (Herhaling)"
            type="password"
            required
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-btn
            color="primary"
            class="no-text-transform display-1"
            type="submit"
            @click="registerTry"
            >Registreer
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="loadingShow" width="400" persistent>
      <v-card>
        <div class="pa-10">
          <h3 class="text-center mb-10">
            {{ loadingTitle }}
          </h3>
          <v-row class="justify-center">
            <v-progress-circular
              v-if="loadingStatus === 'busy'"
              :size="150"
              :width="6"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-slide-y-transition>
              <v-icon
                size="150"
                color="primary"
                v-if="loadingStatus === 'succeeded'"
                >mdi-check
              </v-icon>
              <v-icon size="150" color="error" v-if="loadingStatus === 'failed'"
                >mdi-alert-circle-outline
              </v-icon>
            </v-slide-y-transition>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Form",
  //TODO add all possible field to the data of this component. Next, load input fields according to the fields required
  data() {
    return {
      formValid: true,

      qr: "",
      email: "",
      password: "",

      emailRe: "",
      passwordRe: "",

      invokedModels: {
        license_plate: "",
        birth_date: "",
        full_name: "",
        address: "",
        gender: "",
        opt_in_promotion: "",
        opt_in_newsletter: "",
        phone_number: ""
      },

      //active-rules
      activeRules: {
        qr: [],
        email: [],
        emailRe: [],
        password: [],
        passwordRe: []
      },

      //rules

      rules: {
        qr: [v => !!v || "QR-code is vereist"],
        email: [
          v => !!v || "E-mail is vereist",
          v => /.+@.+\..+/.test(v) || "E-mail is niet geldig"
        ],
        emailRe: [
          v => !!v || "E-mail is vereist",
          v => v === this.email || "Herhaling onjuist"
        ],
        password: [
          v => !!v || "Wachtwoord is vereist",
          v => v.length > 7 || "Wachtwoord moet minimaal 8 tekens hebben"
        ],
        passwordRe: [
          v => !!v || "Wachtwoord is vereist",
          v => v === this.password || "Herhaling onjuist"
        ]
      },

      loadingShow: false,
      loadingTitle: "",
      loadingStatus: ""
    };
  },
  methods: {
    registerTry(e) {
      e.preventDefault();
      //apply rules
      this.activeRules = this.rules;

      this.$refs.regform.validate();

      this.$nextTick(() => {
        if (this.formValid) {
          this.register();
        }
      });
    },
    register() {
      this.loadingShow = true;
      this.loadingTitle = "Registreren...";
      this.loadingStatus = "busy";

      this.$store
        .dispatch("user/register", {
          user: {
            email: this.email,
            password: this.password,
            address: this.address,
            city: this.city,
            org_id: this.$organization.id,
            qr: this.qr
          }
        })
        .then(() => {
          this.loadingTitle = "Registratie gelukt!";
          this.loadingStatus = "succeeded";
        })
        .catch(() => {
          this.loadingTitle = "Registratie mislukt :(";
          this.loadingStatus = "failed";
        });
    }
  },
  watch: {
    loadingStatus: function(val) {
      if (val === "succeeded" || val === "failed") {
        setTimeout(() => {
          this.loadingShow = false;
          this.loadingStatus = "";
          if (val === "succeeded") {
            this.$router.push("/");
          }
        }, 2000);
      }
    }
  }
};
</script>

<style scoped></style>
